import React from 'react';
import { useLocation } from 'react-router-dom';
import { Product, StockStatus } from '../../../types';
import { ProductCard as CnProductCard } from '../coffeenova/ProductCard';
import { toCardProduct } from '../coffeenova/adapters';

/** Fälten som butiken räknar fram för kortet (paketens besparing, raden under namnet, lagerstatus). */
export type ShopCardProduct = Product & {
    boostAmount?: number;
    bundleSavings?: number;
    bundleImages?: string[];
    shopSubtitle?: string;
    shopStock?: StockStatus;
};

interface CardProps {
    product: ShopCardProduct;
    onAddToCart: (product: Product) => void;
}

/**
 * Produktkortet i shoppen och i "Du kanske också gillar" (Jonathans design):
 * bara bild 1, namn, raden under namnet och pris. "Slut i lager" visas aldrig
 * på kortet; där står det på produktsidan. Hela kortet är en riktig länk till
 * produktsidan, så att den också går att öppna i en ny flik.
 */
export const CardClassic: React.FC<CardProps> = ({ product, onAddToCart }) => {
    const location = useLocation();
    const href = `#${location.pathname}?product=${encodeURIComponent(product.id)}`;
    return <CnProductCard product={toCardProduct(product, href)} onSelect={() => onAddToCart(product)} />;
};
